import { HStack, Text } from '@skin-seoul/design-system';

import { useProductCard } from '../ProductCardContext';
import { formatCurrency } from '@skin-seoul/service';
import { Condition } from '@skin-seoul/utils';

export const ProductCardInfoPrice = () => {
  const { currency, originalPrice, salePrice } = useProductCard();

  const discountPercentage = Math.round(((originalPrice - (salePrice ?? 0)) / originalPrice) * 100);

  return (
    <HStack alignItems="center" gap={1}>
      <Condition
        expression={Boolean(salePrice)}
        then={
          <Text color="primary.400" textStyle="paragraph.large" fontWeight="semibold" whiteSpace="nowrap">
            {discountPercentage}%
          </Text>
        }
      />
      <Text textStyle="paragraph.large" fontWeight="semibold" color="neutral.700">
        {formatCurrency(currency, salePrice ?? originalPrice)}
      </Text>
    </HStack>
  );
};
